import { EXTENSION_POINT } from './globals.mjs';

const register = extend => shopify.extend(EXTENSION_POINT, extend);

export { register };
